/**
 * Shop All Side Menu
 */
(() => {
  const query = document.querySelector('.ex-name-hometest .verticalmenu nav');
  if (!query) return;

  const tier1s = [];

  /**
   * Logo
   */
  document.querySelector('.verticalmenu nav').prepend(
    document.querySelector('.logo').cloneNode(true),
  );

  /**
   * Search Form
   */
  const searchForm = document.querySelector('.header-full .search-form');
  if (searchForm) {
    const clonedSearchForm = searchForm.cloneNode(true);
    clonedSearchForm.classList.add('shop-all-search');

    // Insert after logo
    const logoElement = document.querySelector('.verticalmenu nav .logo');
    logoElement.insertAdjacentElement('afterend', clonedSearchForm);
  }

  /**
   * Tier 1
   */
  document.querySelectorAll('.verticalmenu nav .cd-dropdown-content > li.has-children > a').forEach((item) => {
    tier1s.push(item.outerHTML);
    item.removeAttribute('href');
    item.innerHTML = `
        <div class="background"></div>
        <p>${item.innerHTML}</p>
      `;

    // Handle Hover Functionality
    item.addEventListener('mouseenter', (e) => {
      document.querySelectorAll('.verticalmenu nav .cd-dropdown-content > li.has-children')
        .forEach((itemmenu) => {
          if (itemmenu === e.currentTarget.parentNode) return;
          itemmenu.classList.remove('active');
        });
      e.currentTarget.parentNode.classList.add('active');
    });
  });

  /**
   * Tier 2 Sidebar
   */
  document.querySelectorAll('.verticalmenu nav .cd-dropdown-content > li.has-children .cd-secondary-dropdown').forEach((sidemenu, index) => {
    sidemenu.querySelector('.go-back').remove(); // remove back button

    sidemenu.innerHTML = `
      <div class="nLeft">
        <div class="nTop">
          ${`${tier1s[index]}`}
        </div>
        <div class="nBottom">
          ${sidemenu.innerHTML}
        </div>
      </div>
    `;

    // Search box
    sidemenu.querySelector('.sideimage')?.remove();

    // Add "View All" links to tier 3 categories
    sidemenu.querySelectorAll('.nBottom > li').forEach((tier2Item) => {
      const tier2Link = tier2Item.querySelector(':scope > a');
      const tier3Container = tier2Item.querySelector('.is-hidden');

      if (tier2Link && tier3Container) {
        const viewAllLink = document.createElement('li');
        viewAllLink.innerHTML = `<a href="${tier2Link.href}" class="view-all-link">View All <svg width="12" height="6" viewBox="0 0 12 6" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.55641 0.111832C8.38906 0.272615 8.38906 0.532342 8.55641 0.693125L10.5303 2.58954H0.429108C0.193099 2.58954 0 2.77506 0 3.00181C0 3.22855 0.193099 3.41407 0.429108 3.41407H10.5217L8.55641 5.29812C8.38906 5.4589 8.38906 5.71863 8.55641 5.87941C8.72376 6.0402 8.9941 6.0402 9.16145 5.87941L11.8906 3.25741C12.0365 3.11312 12.0365 2.88637 11.8906 2.74208L9.16574 0.111832C9.00268 -0.036583 8.74951 -0.036583 8.58216 0.10771H8.55641V0.111832Z" fill="#2b2b2b"/></a>`;
        tier3Container.appendChild(viewAllLink);
      }
    });

    // Close button
    let close = document.createElement('div');
    close.innerHTML = '<a class="close-button">&times;</a>';
    close = close.firstElementChild;
    close.setAttribute('href', 'javascript:void(0)');
    close.addEventListener('click', () => {
      sidemenu.parentNode.classList.remove('active');
    });
    sidemenu.querySelector('.nLeft').prepend(close);
  });

  // Close button
  let close = document.createElement('div');
  close.innerHTML = '<a class="close-button">&times;</a>';
  close = close.firstElementChild;
  close.setAttribute('href', 'javascript:void(0)');
  close.addEventListener('click', () => {
    document.querySelector('body').click();

    document.querySelectorAll('.verticalmenu nav .cd-dropdown-content > li.has-children').forEach((itemmenu) => {
      itemmenu.classList.remove('active');
    });
  });
  document.querySelector('.cd-dropdown').prepend(close);
})();
